import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import HomePage from "./views/HomePage.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import hotelpage from "./views/Hotelpage.vue";
import hotellist from "./views/Hotellist.vue";
import hoteldetail from "./views/Hoteldetail.vue";
import hotelbooking from "./views/HotelBooking.vue";
import terms from "./views/Terms.vue";
import privacy from "./views/Privacy.vue";
import aboutus from "./views/About.vue";
import contactus from "./views/Contact.vue";
import supportmain from "./views/SupportMain.vue";
import completedorderr from "./views/CompletedOrder.vue";
import partner from "./views/PartnerWithUsForm.vue";
import visa from "./views/visa.vue";

Vue.use(Router);

export default new Router({
    linkExactActiveClass: "active",
    routes: [{
            path: "/home",
            name: "homepage",
            components: {
                header: AppHeader,
                default: HomePage,
                footer: AppFooter
            }
        },
        {
            path: "/",
            name: "hotel",
            components: {
                header: AppHeader,
                default: hotelpage,
                footer: AppFooter
            }
        },
        {
            path: "/hotellist",
            name: "hotellist",
            components: {
                header: AppHeader,
                default: hotellist,
                footer: AppFooter
            }
        },
        {
            path: "/hoteldetail",
            name: "hoteldetail",
            components: {
                header: AppHeader,
                default: hoteldetail,
                footer: AppFooter
            }
        },
        {
            path: "/bookhotel",
            name: "bookhotel",
            components: {
                header: AppHeader,
                default: hotelbooking,
                footer: AppFooter
            }
        },
        {
            path: "/landing",
            name: "landing",
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter
            }
        },
        {
            path: "/terms",
            name: "terms",
            components: {
                header: AppHeader,
                default: terms,
                footer: AppFooter
            }
        },
        {
            path: "/privacy",
            name: "privacy",
            components: {
                header: AppHeader,
                default: privacy,
                footer: AppFooter
            }
        },
        {
            path: "/aboutus",
            name: "aboutus",
            components: {
                header: AppHeader,
                default: aboutus,
                footer: AppFooter
            }
        },
        {
            path: "/contactus",
            name: "contactus",
            components: {
                header: AppHeader,
                default: contactus,
                footer: AppFooter
            }
        },
        {
            path: "/partner",
            name: "partner",
            components: {
                header: AppHeader,
                default: partner,
                footer: AppFooter
            }
        },
        {
            path: "/myorders",
            name: "myorders",
            components: {
                header: AppHeader,
                default: supportmain,
                footer: AppFooter
            }
        },
        {
            path: "/orderdone",
            name: "orderdone",
            components: {
                header: AppHeader,
                default: completedorderr,
                footer: AppFooter
            }
        },

        {
            path: "/login",
            name: "login",
            components: {
                header: AppHeader,
                default: Login,
                footer: AppFooter
            }
        },
        {
            path: "/register",
            name: "register",
            components: {
                header: AppHeader,
                default: Register,
                footer: AppFooter
            }
        },
        {
            path: "/profile",
            name: "profile",
            components: {
                header: AppHeader,
                default: Profile,
                footer: AppFooter
            }
        },
        {
            path: "/hotelpage",
            name: "hotelpage",
            components: {
                header: AppHeader,
                default: hotelpage,
                footer: AppFooter
            }
        },
        {
            path: "/visa",
            name: "visa",
            components: {
                header: AppHeader,
                default: visa,
                footer: AppFooter
            }
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});